import { produce } from 'immer';
import { createJSONStorage } from 'zustand/middleware';

import { StoreHelper } from '@helpers';
import {
	AccountChallengeOutputDto,
	AccountCmdUrlOutputDto,
	AccountDeleteCookiesOutputDto,
	AccountGenerateCaptchaOutputDto,
	AccountLoginOutputDto,
	AccountSafeOutputDto,
	AccountUserCredentialsOutputDto,
	AccountUserOutputDto,
	ContentsClientCookiesOutputDto,
} from '@types';

export interface ServicesState {
	accountChallenge?: AccountChallengeOutputDto | null;
	accountLogin?: AccountLoginOutputDto | null;
	accountSafe?: AccountSafeOutputDto | null;
	accountUserCredentials?: AccountUserCredentialsOutputDto | null;
	accountGenerateCaptcha?: AccountGenerateCaptchaOutputDto | null;
	contentsClientCookies?: ContentsClientCookiesOutputDto | null;
	accountDeleteCookies?: AccountDeleteCookiesOutputDto | null;
	accountUser?: AccountUserOutputDto | null;
	accountCmdUrl?: AccountCmdUrlOutputDto | null;
}

export const servicesInitialState: ServicesState = {
	accountChallenge: undefined,
	accountLogin: undefined,
	accountSafe: undefined,
	accountUserCredentials: undefined,
	accountGenerateCaptcha: undefined,
	contentsClientCookies: undefined,
	accountDeleteCookies: undefined,
	accountUser: undefined,
	accountCmdUrl: undefined,
};

interface UseServicesStoreOutput extends ServicesState {
	saveServiceResponse: (state: ServicesState) => void;
	resetState: (state: ServicesState) => void;
}

export const useServicesStore = StoreHelper.createStore<UseServicesStoreOutput>(
	(set) => ({
		...servicesInitialState,
		saveServiceResponse: (state: ServicesState) =>
			set(
				produce((currentState: ServicesState) => ({ ...currentState, ...state })),
				false,
				'saveServiceResponse'
			),
		resetState: function (state: ServicesState) {
			set({ ...servicesInitialState, ...state }, false, 'resetState');
		},
	}),

	{ name: 'Services', storage: createJSONStorage(() => sessionStorage) }
);
